import { NgClass } from '@angular/common';
import { CdkMenuTrigger } from '@angular/cdk/menu';
import { ChangeDetectionStrategy, Component, input, output, signal, TemplateRef } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-top-bar-button',
    imports: [CdkMenuTrigger, NgClass, TooltipModule],
    templateUrl: './top-bar-button.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TopBarButtonComponent {
    icon = input.required<string>();
    tooltip = input<string>();
    menu = input<TemplateRef<unknown>>();
    // Pressed/toggled-on state (e.g. the presentation toggle while presenting): a persistent tint
    // the hover style would otherwise only show transiently.
    active = input<boolean>(false);

    // Menu-hosting buttons (profile, overflow ⋮) also read as pressed while their menu is open.
    isMenuOpen = signal(false);

    clicked = output<Event>();
}
